import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

// event domain 으로 만든 api, afevent.sooplive.co.kr. LEGACY
const AfEventApi = ApiCore(globalDomains.AFEVENT_AFREECATV);
export default AfEventApi;
